import React from 'react';
import { Icon } from './Icon.js';
export const IconProcessNode = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M10 20H3V12H10", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M14 4L21 4L21 12L14 12", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("rect", { x: "10", y: "2", width: "4", height: "4", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("rect", { x: "10", y: "10", width: "4", height: "4", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("rect", { x: "10", y: "18", width: "4", height: "4", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconProcessNode.js.map